import React from "react";
import PropTypes from "prop-types";
import ErrorFallback from "./ErrorFalback";
import { useAuth } from "context/authContext";
import { addErrorLog } from "services/api";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const { employee } = this.props;
    // Log error to a monitoring service here if needed

    addErrorLog({
      errorName: error.name,
      errorMessage: error.message,
      errorStack: error.stack,
      componentStack: errorInfo.componentStack,
      pageUrl: window.location.href,
      userAgent: navigator.userAgent,
      employeeId: employee.id,
      employeeName: employee.name,
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  employee: PropTypes.any,
};

function ErrorBoundaryWithAuth({ children }) {
  const { employee } = useAuth();

  return <ErrorBoundary employee={employee}>{children}</ErrorBoundary>;
}

ErrorBoundaryWithAuth.propTypes = {
  children: PropTypes.any,
};

export default ErrorBoundaryWithAuth;
